module.exports = __webpack_public_path__ + "static/media/404icon.bdcb4e3a.svg";